module.exports = __webpack_public_path__ + "img/car-icon-3-current.b92ed866.png";